import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeftSmallDisabled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.47568 11.805L5.75559 9.00195H14.5V7.00195L5.75559 7.00195L8.47568 4.19995L7.04274 2.80495L2 8.00195L7.04274 13.2L8.47568 11.805Z",
		fill: "black",
		fillOpacity: .38
	})]
});
const ForwardRef = forwardRef(SvgArrowLeftSmallDisabled);
export { ForwardRef as ReactComponent };
